import { createModuleStore } from '../utils'

export const useCategoriesStore = createModuleStore(
  'categories',
  {
    type: 'Category',
    pageHeading: 'Categories',
    noHistory: true,
    sortingOn: 'toolbar',
    statusesFilterName: 'statuses',
    uploadOptionsCsv: '',
    uri: '/categories',
    serviceUri: '/categories',
    listingModuleName: 'Config',
    listingActivityName: 'View Category',
    formModuleName: 'Config',
    formActivityName: 'Edit Category',
    allFields: [
      {
        key: 'name',
        title: 'NAME',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'description',
        title: 'DESCRIPTION',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'parent',
        title: 'PARENT',
        visible: true,
        sortable: true,
        disabled: false,
        type: 'category',
      },
      {
        key: 'samplingPeriodSeconds',
        title: 'SAMPLING PERIOD SECONDS',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'samplingThreshold',
        title: 'SAMPLING THRESHOLD',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'multipleTagsAllowed',
        title: 'MULTIPLE TAGS ALLOWED',
        visible: true,
        type: 'booleanToYesNo',
        sortable: true,
        disabled: false,
      },
      {
        key: 'hidden',
        title: 'HIDDEN',
        visible: true,
        type: 'booleanToYesNo',
        sortable: true,
        disabled: false,
      },
      {
        key: 'externalId',
        title: 'UUID',
        visible: false,
        sortable: false,
        disabled: false,
      },
      {
        key: 'createdBy',
        title: 'CREATED BY',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'createdTimestamp',
        title: 'CREATED TIME',
        type: 'datetime',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'lastModifiedBy',
        title: 'LAST MODIFIED BY',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'lastModifiedTimestamp',
        title: 'LAST MODIFIED TIME',
        type: 'datetime',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'status',
        title: 'STATUS',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'actions',
        title: 'ACTIONS',
        visible: true,
        disabled: true,
        sortable: false,
      },
    ],
  },
  {
    parentName: null,
    multipleTagsAllowedLabel: null,
    hiddenLabel: null,
  },
  {
    copy(item) {
      const obj = {
        description: item.description,
        multipleTagsAllowed: item.multipleTagsAllowed,
        hidden: item.hidden,
        samplingPeriodSeconds: item.samplingPeriodSeconds,
        samplingThreshold: item.samplingThreshold,
        parent: item.parent,
      }
      return obj
    },
    multipleTagsAllowedUpdated(allowed) {
      const store = useCategoriesStore()
      const prefix = 'Multiple Tags'
      const suffix = 'Allowed'
      store.form.multipleTagsAllowedLabel = prefix + (allowed ? ' ' : ' Not ') + suffix
    },
    hiddenUpdated(hidden) {
      const store = useCategoriesStore()
      store.form.hiddenLabel = hidden ? 'Hidden, Not visible to all' : 'Visible to all'
    },
    resetPageFilters() {
      const store = useCategoriesStore()
      store.resetBaseFilters()
    },
  },
  {
    actionBindings: {
      multipleTagsAllowed: 'multipleTagsAllowedUpdated',
      hidden: 'hiddenUpdated',
    },
    fields: [
      {
        id: 'category_name',
        name: 'name',
        label: 'Name',
        size: 12,
        component: 'NInput',
        componentProps: { placeholder: 'Enter name of the category' },
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
          {
            trigger: 'blur',
            remoteValidator: 'isNameUnique',
          },
        ],
      },
      {
        id: 'category_parent',
        name: 'parent',
        label: 'Parent Category',
        size: 12,
        component: 'ArsSmartSelect',
        submitValueKey: 'externalId',
        componentProps: {
          multiple: false,
          placeholder: 'Select category',
          clearable: true,
          dxTableName: 'Categories',
          serviceUri: '/categories',
          optionsLabel: 'name',
        },
        rules: [
          {
            required: false,
            trigger: 'blur',
          },
        ],
      },
      {
        id: 'category_sampling_threshold',
        name: 'samplingThreshold',
        label: 'Sampling Threshold',
        size: 6,
        component: 'NInputNumber',
        defaultValue: 10,
        componentProps: { placeholder: 'Enter sampling threshold' },
        rules: [
          {
            type: 'number',
            required: true,
            trigger: ['blur', 'input'],
            min: 1,
          },
        ],
      },
      {
        id: 'category_sampling_period_seconds',
        name: 'samplingPeriodSeconds',
        label: 'Sampling Period(Seconds)',
        size: 6,
        defaultValue: 1,
        componentProps: { placeholder: 'Enter sampling period' },
        component: 'NInputNumber',
        rules: [
          {
            type: 'number',
            required: true,
            trigger: ['blur', 'input'],
            min: 1,
          },
        ],
      },
      {
        id: 'category_multiple_tags_allowed',
        name: 'multipleTagsAllowed',
        templateLabel: 'multipleTagsAllowedLabel',
        label: 'Supports Multiple RFID Tags',
        size: 6,
        component: 'NCheckbox',
        defaultValue: false,
        componentProps: {},
        rules: [
          {
            type: 'boolean',
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'category_hidden',
        name: 'hidden',
        templateLabel: 'hiddenLabel',
        label: 'Hidden?',
        size: 6,
        component: 'NCheckbox',
        defaultValue: false,
        componentProps: {},
        rules: [
          {
            type: 'boolean',
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'category_description',
        name: 'description',
        label: 'description',
        size: 24,
        component: 'NInput',
        componentProps: { placeholder: 'Enter description' },
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
    ],
  }
)
